import module from 'module';
import $ from 'jquery';

import templateUrl from './item-sticker-view.template.html';
import './item-sticker-view.style.less';

class ItemStickerViewComponent {
  constructor($route, $location, http, nav, printService, $timeout) {
    this.$route = $route;
    this.$location = $location;
    this.http = http;
    this.nav = nav;
    this.printService = printService;
    this.$timeout = $timeout;
  }

  $onInit() {
    const itemId = this.$route.current.params['itemId'];
    this.$timeout(() => {
      this.http.post(`/print/ITEM_STICKER/json`, {itemId: itemId}).success(doc => {
        this.doc = doc;

        return this.printService.printToContainer(doc, {
          autoPrint: false,
          backgroundEnabled: true,
          container: $('.iframe-preview')
        });
      });
    });
  }

  redirectBack() {
    this.nav.back()
  }

  print() {
    this.printService.printToContainer(this.doc, {
      autoPrint: true,
      backgroundEnabled: false,
      container: $('.iframe-invisible')
    });
  }
}

module.component('itemStickerView', {
  templateUrl: templateUrl,
  controller: ItemStickerViewComponent
});